var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaveLines = function SvgWaveLines(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1949.009,
    height: 427.876,
    viewBox: "0 0 1949.009 427.876",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%",
    id: "curve-gradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "#1ef6c7",
    offset: "0%"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4s",
    values: "#1ef6c7; #2aa0eb; #1ef6c7",
    attributeName: "stop-color"
  })), /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    stopColor: "#2aa0eb",
    offset: "100%"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4s",
    values: "#2aa0eb; #1ef6c7; #2aa0eb",
    attributeName: "stop-color"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%",
    id: "curve-gradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "#0d2a65",
    offset: "0%"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4s",
    values: "#0d2a65; #2aa0eb; #0d2a65",
    attributeName: "stop-color"
  })), /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    stopColor: "#2aa0eb",
    offset: "100%"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4s",
    values: "#2aa0eb; #0d2a65; #2aa0eb",
    attributeName: "stop-color"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%",
    id: "curve-gradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "#cdcdce",
    offset: "0%"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4s",
    values: "#cdcdce; #f0f2f4; #cdcdce",
    attributeName: "stop-color"
  })), /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    stopColor: "#f0f2f4",
    offset: "100%"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4s",
    values: "#f0f2f4; #cdcdce; #f0f2f4",
    attributeName: "stop-color"
  }))), /*#__PURE__*/React.createElement("style", null, "\n      .cls-line {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9915",
    transform: "translate(25.889 -545.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M-31.569,31.837S142.4,146.3,225.324,143.971s146.43-46.539,211.769-46.539,119.024,46.539,210.567,46.539S792.262,31.837,851.23,31.837s171.161,65.6,226.809,65.6,152.618-79.6,208.284-79.6,68.113,14.008,207.73,14.008S1600.657,0,1696.542,0s134.044,49.214,215.329,109.722",
    transform: "translate(8.45 692.155)",
    stroke: "url('#curve-gradient-2')",
    className: "cls-line",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    d: "M0,322.7S143.067,208.84,226.376,205.876s147.113,101.2,212.758,101.2S558.714,84.592,650.684,84.592s145.276,89.57,204.519,89.57,111.347-89.57,210.928-89.57,170.27,121.284,226.2,121.284,68.431-109.622,208.7-109.622S1608.129,0,1704.461,0s0,136.455,215.41,170.841",
    transform: "translate(-10.55 647.581)",
    stroke: "url('#curve-gradient-1')",
    className: "cls-line",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3",
    d: "M-.283,44.421S163.295-3.673,246.222-1.272,392.7,45.387,458.039,45.442,577.03-1,668.577-.919s144.7,112.251,203.67,112.3,171.114-65.45,226.765-65.4,152.69,79.728,208.359,79.774,68.1-13.951,207.728-13.834,106.634,31.925,202.523,32,134.01-49.1,215.249-109.538",
    transform: "translate(-11.469 548.719) rotate(3)",
    stroke: "url('#curve-gradient-3')",
    className: "cls-line",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaveLines, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wave_lines.6a65e0fb.svg";
export { ForwardRef as ReactComponent };